import { l } from '../../lib/imports'
import { common } from '../../main/common-sidecar'
import type { IBounds } from './voyageCamera'
import { voyageCameraStarmap_mover } from './voyageCameraStarmap_mover-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'

// TODO: extract to common camera
export interface IVoyageCameraStarmap {
  zoom: number
  cameraX: number
  cameraY: number
  bounds: IBounds
}

let _obj: IVoyageCameraStarmap | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setCameraXY(0, 0)
  }
  return _obj
}

function create() {
  let bounds = 128 * 20
  let obj: IVoyageCameraStarmap = {
    zoom: 1,
    cameraX: 0,
    cameraY: 0,
    bounds: {
      x: -bounds,
      y: -bounds,
      w: 100 * 32 + bounds * 2,
      h: 100 * 32 + bounds * 2,
    },
  }
  return obj
}

export function getUiMousePosition() {
  let s = common.getPhaserScene()
  let mx = s.input.mousePointer.x
  let my = s.input.mousePointer.y
  return { mx, my }
}

export function getAdjustedMousePosition() {
  let s = common.getPhaserScene()
  let mx = s.input.mousePointer.x
  let my = s.input.mousePointer.y
  let obj = get()
  let zoom = getZoom()
  let gx = (mx + obj.cameraX) / zoom
  let gy = (my + obj.cameraY) / zoom
  return { x: gx, y: gy }
}

export function getGamePositionToUiPosition(gx: number, gy: number) {
  let obj = get()
  let zoom = getZoom()
  let mx = gx * zoom - obj.cameraX
  let my = gy * zoom - obj.cameraY
  return { x: mx, y: my }
}

export function getGameBounds() {
  let scale = common.getPhaserScene().sys.game.scale
  return { width: scale.width, height: scale.height }
}

export function centerOn(x: number, y: number) {
  let obj = get()
  let gb = getGameBounds()
  setCameraXY(x * obj.zoom - gb.width / 2, y * obj.zoom - gb.height / 2)
}

export function getCenter() {
  let obj = get()
  let gb = getGameBounds()
  let x = obj.cameraX + gb.width / 2 / obj.zoom
  let y = obj.cameraY + gb.height / 2 / obj.zoom
  return { x, y }
}

export const getCenterXY = () => {
  let obj = get()
  let gb = getGameBounds()
  return {
    x: (obj.cameraX + gb.width / 2) / obj.zoom, // / data.zoom,
    y: (obj.cameraY + gb.height / 2) / obj.zoom, // / data.zoom,
  }
}

export function update() {
  let obj = get()
  // voyageCamera_shaker.update()
  voyageCameraStarmap_mover.update(obj)
  // voyageCamera_zoomer.update()
  _updateLayers()

  // let ap = common.getPhaserScene().game.input.activePointer
}

function _updateLayers() {
  let obj = get()
  let layers = voyageLayers.getLayersOnStarmap()

  // let gs = voyageCamera_shaker.get()
  let cx = obj.cameraX //+ gs.shakeX
  let cy = obj.cameraY //+ gs.shakeY
  // console.log('klayers?', layers.length)
  l.forEach(layers, (c) => {
    c.x = -cx
    c.y = -cy
  })
}

export function setCameraXY(x: number, y: number) {
  let obj = get()
  let bounded = constrainToBounds(x, y, obj.bounds)
  obj.cameraX = bounded.x
  obj.cameraY = bounded.y
  _updateLayers()
}

export function constrainToBounds(x: number, y: number, bounds: IBounds) {
  let ix = x
  let iy = y
  let gb = getGameBounds()

  let zoom = get().zoom
  let bx = bounds.x * zoom
  let by = bounds.y * zoom

  if (ix < bx) {
    ix = bx
  }
  if (iy < by) {
    iy = by
  }

  let bw = bounds.w * zoom
  let br = bx + bw - gb.width
  if (gb.width > bw) {
    br += (gb.width - bw) / 2
  }
  if (ix > br) {
    ix = br
  }

  let bh = bounds.h * zoom
  let bb = by + bh - gb.height
  if (gb.height > bh) {
    bb += (gb.height - bh) / 2
  }
  if (iy > bb) {
    iy = bb
  }

  x = ix
  y = iy
  return { x, y }
}

export function setZoom(newZoom: number) {
  let obj = get()

  if (newZoom === obj.zoom) {
    return
  }

  let center = getCenterXY()
  obj.zoom = newZoom
  l.forEach(voyageLayers.getLayersOnMainCamera(), (c) => {
    c.scale = newZoom
  })

  centerOn(center.x, center.y)
  center = getCenterXY()
}

export function getZoom() {
  return get().zoom
}
